<div [class]="containerClass">
  <ul class="ng-toast__list">
    <devapp-toast *ngFor="let toast of toasts" [toast]="toast" [class]="itemClass"></devapp-toast>
  </ul>
</div>
